module.exports = __webpack_public_path__ + "interessados.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/interessados.png
 ** module id = 752
 ** module chunks = 0
 **/